<script>
  import {DRIVER_SIZES}         from '../../../../constants/drivers-by-size';
  import {sizeClass}            from '../../../../services/size-class';
  import {driverSizeFlagsStore} from '../../../../stores/filters/driver-size-flags-store';
</script>

<style>
  .size-large  { background-image: url('img/drivers/Bowser.png'); }
  .size-medium { background-image: url('img/drivers/Mario.png'); }
  .size-small  { background-image: url('img/drivers/Toad.png'); }

  label {
    padding-right: 40px;
  }
</style>

<template lang="pug" src="./driver-size-filter.pug"></template>
